// Landing chooser (docs/81 4.3): "I have a GB-Link" shows the existing trade flow; "I have a Kizuna" shows the guide.
// Invite links (?room=, ?game=) and #gblink go straight to the GB-Link flow.

type Route = "gblink" | "kizuna" | "";

const panels: Record<"gblink" | "kizuna", HTMLElement> = {
  gblink: document.getElementById("route-gblink")!,
  kizuna: document.getElementById("route-kizuna")!,
};

function setRoute(route: Route, scroll: boolean): void {
  panels.gblink.hidden = route !== "gblink";
  panels.kizuna.hidden = route !== "kizuna";
  document.querySelectorAll<HTMLElement>(".route-card").forEach((c) => c.setAttribute("aria-pressed", String(c.dataset.route === route)));
  const hash = route ? `#${route}` : "";
  history.replaceState(null, "", location.pathname + location.search + hash);
  if (scroll && route) panels[route].scrollIntoView({ behavior: "smooth", block: "start" });
}

document.querySelectorAll<HTMLElement>("[data-route]").forEach((el) =>
  el.addEventListener("click", () => setRoute((el.dataset.route ?? "") as Route, true)),
);

const q = new URLSearchParams(location.search);
const initial: Route = q.has("room") || q.has("game") || location.hash === "#gblink" ? "gblink" : location.hash === "#kizuna" ? "kizuna" : "";
setRoute(initial, false);
